import * as moment from 'moment';
import * as _ from 'lodash';

class InstructionsController {
  // Shared state
  public fromDate: Date;
  public toDate: Date;
  public displayMCB: boolean = true;
  public threshold: number = 10;
  public midRateDate: Date;
  public midRates: any;
  public currentDate: Date;
  public lastTwelveMonths: Date;

  // Tab reload flags
  public reloadFinalParameters: boolean = false;
  public reloadTempParameters: boolean = false;
  public reloadInstructionSheets: boolean = false;

  // Flags to track if tabs should load when visited
  public shouldLoadTempRun: boolean = false;
  public shouldLoadFinalRun: boolean = false;
  public shouldLoadInstructions: boolean = false;

  /** @ngInject */
  constructor() {
    var date = new Date();
    this.currentDate = date;
    this.lastTwelveMonths = new Date(
      moment(date).subtract(12, 'months').startOf('month').format('YYYY-MM-DD')
    );

    // Load cached values from localStorage
    const savedFromDate = localStorage.getItem('instructionsFromDate');
    const savedToDate = localStorage.getItem('instructionsToDate');
    const savedDisplayMCB = localStorage.getItem('instructionsDisplayMCB');
    const savedThreshold = localStorage.getItem('instructionsThreshold');
    const savedMidRateDate = localStorage.getItem('instructionsMidRateDate');

    // Initialize dates from cache or defaults (last month), clamped to 12-month minimum
    if (savedFromDate) {
      this.fromDate = new Date(savedFromDate);
      if (moment(this.fromDate).isBefore(moment(this.lastTwelveMonths))) {
        this.fromDate = new Date(this.lastTwelveMonths.getTime());
      }
    } else {
      this.fromDate = new Date(
        moment(date).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      );
    }

    if (savedToDate) {
      this.toDate = new Date(savedToDate);
      if (moment(this.toDate).isBefore(moment(this.lastTwelveMonths))) {
        this.toDate = new Date(
          moment(date).subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
        );
      }
    } else {
      this.toDate = new Date(
        moment(date).subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
      );
    }

    // Load displayMCB from cache or default to true
    if (savedDisplayMCB !== null) {
      this.displayMCB = savedDisplayMCB === 'true';
    } else {
      this.displayMCB = true;
    }

    // Load threshold from cache or default to 10
    if (savedThreshold !== null) {
      this.threshold = parseFloat(savedThreshold);
    } else {
      this.threshold = 10;
    }

    // Load midRateDate from cache or default to toDate
    if (savedMidRateDate) {
      this.midRateDate = new Date(savedMidRateDate);
    } else {
      this.midRateDate = new Date(this.toDate);
    }
  }

  handleSearch = () => {
    // Save current values to localStorage
    localStorage.setItem('instructionsFromDate', this.fromDate.toISOString());
    localStorage.setItem('instructionsToDate', this.toDate.toISOString());
    localStorage.setItem('instructionsDisplayMCB', this.displayMCB.toString());
    localStorage.setItem('instructionsThreshold', this.threshold.toString());
    localStorage.setItem('instructionsMidRateDate', this.midRateDate.toISOString());

    // Set flags for all tabs to load when visited
    this.shouldLoadTempRun = true;
    this.shouldLoadFinalRun = true;
    this.shouldLoadInstructions = true;

    // Trigger reload for currently active tab (if any)
    // The tab will check the flag when it becomes active
    this.reloadTempParameters = !this.reloadTempParameters;
    this.reloadFinalParameters = !this.reloadFinalParameters;
    this.reloadInstructionSheets = !this.reloadInstructionSheets;
  };

  handleAll = () => {
    // Set max date range (12 months into the past)
    this.fromDate = new Date(this.lastTwelveMonths);
    this.toDate = new Date(
      moment(this.currentDate).subtract(1, 'months').endOf('month').format('YYYY-MM-DD')
    );
    this.midRateDate = new Date(this.toDate);

    // Trigger search (which will save values to localStorage)
    this.handleSearch();
  };


  loadFinalRunParameters = () => {
    // Check if we should load
    if (this.shouldLoadFinalRun) {
      this.shouldLoadFinalRun = false;
      this.reloadFinalParameters = !this.reloadFinalParameters;
    }
  };

  loadTempRumParameters = () => {
    // Check if we should load
    if (this.shouldLoadTempRun) {
      this.shouldLoadTempRun = false;
      this.reloadTempParameters = !this.reloadTempParameters;
    }
  };

  loadInstructionSheets = () => {
    // Check if we should load
    if (this.shouldLoadInstructions) {
      this.shouldLoadInstructions = false;
      this.reloadInstructionSheets = !this.reloadInstructionSheets;
    }
  };

  /** Called when an item is declined on the final run tab so the temp run tab reloads and shows the item again. */
  requestTempRunReload = () => {
    this.reloadTempParameters = !this.reloadTempParameters;
  };

  /** Called when instruction parameters are saved on the temp run tab so the final run tab reloads and shows them. */
  requestFinalRunReload = () => {
    this.reloadFinalParameters = !this.reloadFinalParameters;
  };
}




export const instructions: angular.IComponentOptions = {
  template: require('./fees.instructions.html'),
  controller: InstructionsController
};



// WEBPACK FOOTER //
// ./src/app/fees/instructions/fees.instructions.ts